var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("login", {
    attrs: {
      "app-name": "Showtimes",
      title: _vm.$config.tag_line,
      "bg-color": "#1c1e2f",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }